import React from 'react';
type QuotedListProps = {
  items: string[];
  line: string;
};
export function QuotedList({
  items,
  line
}: QuotedListProps) {
  return <div data-id="element-77" data-mp="jkkzh6epvsd9">
      <ul className="flex flex-wrap gap-2" data-id="element-78" data-mp="jkb8pglulh6i">
        {items.map(item => <li key={item} className="rounded-full bg-brand-light px-4 py-2 text-sm font-semibold text-brand-black" data-id="element-79" data-mp="5swml0wn8zv8">
            {item}
          </li>)}
      </ul>
      <p className="mt-4 text-sm text-gray-600" data-id="element-80" data-mp="3s0ednelksrr5">{line}</p>
    </div>;
}